module.exports = __webpack_public_path__ + "img/fashion_banner_animation.5758f7b4.gif";